import * as client from '../../services/client';
import { TYPES, ErrorMessages } from 'src/common/constants';
import { selectSuiteById } from '../selectors/suites';
import { PATHS } from 'src/common/constants';
import {
  stopLoading,
  startPRLoading,
  stopPRLoading,
  startFormLoading,
  stopFormLoading,
} from '../actions/loader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchSuiteWalkThroughs } from './walkThroughs';
import { fetchCountsDone } from './properties';
import { getPropertyBuildings } from './buildings';
import moment from 'moment';
import { store } from '..';
import { ToastFail } from 'src/helpers/validationHelper';
import { fetchFaqsNotesDocumentsDone } from './faqsNotesDocuments';

const fetchPropertySuitesDone = (payload) => ({
  type: TYPES.FETCH_PROPERTY_SUITES_DONE,
  payload,
});

export const fetchPropertySuites = (id, userId, role, loader) => (dispatch) => {
  if (loader === false) {
  } else {
    dispatch(startPRLoading());
  }
  return client
    .getIndividualPropertySuiteByID(id, userId, role)
    .then((response) => {
      if (response.status === 200) {
        response.json().then((responsejson) => {
          dispatch(fetchPropertySuitesDone(responsejson));
          dispatch(stopPRLoading());
        });
      } else if (response.status === 204) {
        dispatch(fetchPropertySuitesDone([]));
        dispatch(stopPRLoading());
      } else {
        dispatch(stopPRLoading());
      }
    });
};

const saveSuiteDone = (payload) => ({
  type: TYPES.SAVE_SUITE_DONE,
  payload,
});

const setValidation = (payload) => ({
  type: TYPES.SET_VALIDATION,
  payload,
});

export const clearValidation = () => ({
  type: TYPES.CLEAR_VALIDATION,
});

export const saveSuite = (suite) => (dispatch) => {
  dispatch(startFormLoading());
  return client.addSuite(suite).then((response) => {
    dispatch(stopFormLoading());
    dispatch(stopLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(getPropertyBuildings(suite.PropertyId));
        if (responsejson.statusCode === 402) {
          toast.error('🚫 Unit Number already exits please try with other', {
            autoClose: 12000,
            position: 'top-center',
          });
          dispatch(setValidation('message'));
        } else if (
          responsejson.statusCode === 409 ||
          responsejson.statusCode === 400
        ) {
          toast.error('🚫 User already exist with this email address.', {
            autoClose: 12000,
            position: 'top-center',
          });
          dispatch(setValidation('message'));
        } else if (responsejson.statusCode === 200) {
          dispatch(setValidation('Success'));
          toast.success('ⓘ Suite has been added.', {
            autoClose: 10000,
            position: 'top-center',
          });
          dispatch(saveSuiteDone(responsejson.data));
        } else {
          toast.error(
            ' 🚫 Something went wrong with adding a suite, please try again.',
            { autoClose: 12000, position: 'top-center' }
          );
        }
      });
    } else {
      dispatch(stopFormLoading());
      toast.error(
        ' 🚫 Something went wrong with adding a suite, please try again.',
        { autoClose: 12000, position: 'top-center' }
      );
    }
  });
};

const updateSuiteDone = (payload) => ({
  type: TYPES.UPDATE_SUITE_DONE,
  payload,
});

export const updateSuite = (suite, history, property) => (dispatch) => {
  dispatch(startFormLoading());
  return client.updateSuite(suite).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(getPropertyBuildings(suite.propertyId));
        if (responsejson.statusCode === 402) {
          toast.error(
            ' 🚫 That unit number already exits, please try another.',
            {
              autoClose: 12000,
              position: 'top-center',
            }
          );
          dispatch(setValidation('message'));
        } else if (
          responsejson.statusCode === 409 ||
          responsejson.statusCode === 400
        ) {
          toast.error('🚫 User already exist with this email address.', {
            autoClose: 12000,
            position: 'top-center',
          });
          dispatch(setValidation('message'));
        } else if (responsejson.statusCode === 200) {
          toast.success(' ⓘ Suite has been updated.', {
            autoClose: 10000,
            position: 'top-center',
          });
          dispatch(setValidation('Success'));
          if (history) {
            history.push({
              pathname: PATHS.PROPERTIES_VIEW.replace(':id', property.id),
              state: { data: property },
            });
          }
          dispatch(updateSuiteDone(responsejson.data));
        } else {
          dispatch(stopFormLoading());
          toast.error(
            ' 🚫 Something went wrong with updating a suite, please try again.',
            { autoClose: 12000, position: 'top-center' }
          );
        }
      });
    } else {
      dispatch(stopFormLoading());
      toast.error(
        ' 🚫 Something went wrong with updating a suite, please try again.',
        { autoClose: 12000, position: 'top-center' }
      );
    }
  });
};

const deleteUnitDone = (payload) => ({
  type: TYPES.DELETE_UNIT_DONE,
  payload,
});

export const deleteUnit = (id, userId, history, property) => (dispatch) => {
  dispatch(startFormLoading());
  return client.deleteUnit(id, userId).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      toast.success(' ⓘ Unit has been deleted.', {
        autoClose: 10000,
        position: 'top-center',
      });
      if (history) {
        history.push({
          pathname: PATHS.PROPERTIES_VIEW.replace(':id', property.id),
          state: { data: property },
        });
      }
      dispatch(deleteUnitDone(id));
    } else {
    }
  });
};

export const clearSuites = () => ({
  type: TYPES.CLEAR_SUITES,
});

const fetchSuiteByIdDone = (payload) => ({
  type: TYPES.FETCH_SUITE_BY_ID_DONE,
  payload,
});

export const fetchSuiteById = (id) => (dispatch, getState) => {
  const suite = selectSuiteById(getState(), id);
  if (!suite) {
    return client
      .getSuiteById(id)
      .then((response) => dispatch(fetchSuiteByIdDone(response.data)));
  }
};

const fetchSuiteAreasDone = (payload) => ({
  type: TYPES.FETCH_SUITE_AREAS_DONE,
  payload,
});

const fetchSuiteUsersDone = (payload) => ({
  type: TYPES.FETCH_SUITE_USERS_LIST,
  payload,
});

export const fetchSuiteAreas = () => (dispatch) => {
  return client.getSuiteAreas().then((response) => {
    if (response.ok) {
      response.json().then((responsejson) => {
        let other = responsejson.filter((area) => area.name === 'Other');
        responsejson = responsejson.filter((area) => area.name !== 'Other');
        responsejson = [...responsejson, ...other];

        dispatch(fetchSuiteAreasDone(responsejson));
      });
    } else {
      dispatch(fetchSuiteAreasDone([]));
    }
  });
};

export const setWalkThroughStatus = (status, data) => (dispatch) => {
  status = { ...status, ReviewDate: moment().format('MM-DD-YYYY HH:mm:ss') };
  return client
    .setWalkThroughStatus(status)
    .then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            if (status.Status === 'Review') {
              dispatch(fetchSuiteCounts(status.SuiteId));
              toast.success(
                'ⓘ  Congratulations! You have successfully completed the walk-through, We will send an email notification once the PDF is ready for your review.',
                { autoClose: 3000, position: 'top-center' }
              );
            }
            let state = store.getState();
            const userData = state.auth?.user || {};
            const roleName = userData.roles[0].role.name;
            dispatch(fetchSuiteWalkThroughs(status.SuiteId, roleName));
          } else {
            toast.error(
              ' 🚫 Walkthrough status updating failed, please try again.',
              { autoClose: 3000, position: 'top-center' }
            );
          }
        });
      } else {
        toast.error(' 🚫 Something went wrong, please try again.', {
          autoClose: 3000,
          position: 'top-center',
        });
      }
    })
    .catch(() => {
      toast.error(' 🚫 Something went wrong, please try again.', {
        autoClose: 3000,
        position: 'top-center',
      });
    });
};

const fetchedSuiteUsersAddToContactsDone = (payload) => ({
  type: TYPES.FETCHED_SUITE_USERS_ADD_TO_CONTACTS_DONE,
  payload,
});
export const fetchSuiteUsers = (suiteId, type) => (dispatch) => {
  if (type !== false) {
    dispatch(startPRLoading());
  }
  return client
    .fetchSuiteUsers(suiteId)
    .then((response) => {
      if (response.status === 200 && response.ok) {
        dispatch(stopPRLoading());
        response.json().then((responsejson) => {
          dispatch(fetchSuiteUsersDone(responsejson));
          dispatch(fetchedSuiteUsersAddToContactsDone(responsejson));
        });
      } else {
        dispatch(stopPRLoading());
        dispatch(fetchSuiteUsersDone([]));
      }
    })
    .catch(() => {
      dispatch(stopPRLoading());
    });
};

export const clearSuiteUsers = () => ({
  type: TYPES.CLEAR_SUITE_USERS,
});

export const fetchSuiteCounts = (suiteId, role) => (dispatch) => {
  return client.fetchSuiteCounts(suiteId, role).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        if (responsejson.statusCode === 200) {
          dispatch(fetchCountsDone(responsejson.data));
        }
      });
    }
  });
};

const fetchMaintainanceGuidesBySuiteIdDone = (payload) => ({
  type: TYPES.FETCH_MAINTAINANCE_GUIDE_BY_SUITE_ID,
  payload,
});

export const fetchMaintainanceGuideBySuiteId = (id) => (dispatch) => {
  dispatch(startPRLoading());
  return client.fetchMaintainanceGuideBySuiteId(id).then((response) => {
    if (response.ok || response.status === 200) {
      response.json().then((responsejson) => {
        dispatch(fetchMaintainanceGuidesBySuiteIdDone(responsejson));
        dispatch(stopPRLoading());
      });
    }
  });
};

export const onClearMoreDetails = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_MORE_DETAILS_DONE,
  });
};

export const onFetchContactMoreDetails = (id) => (dispatch) => {
  dispatch({
    type: TYPES.IS_FETCH_MORE_DETAILS_LOADING,
  });
  client
    .onFetchContactMoreDetails(id)
    .then((response) => {
      dispatch(stopLoading());
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch({
            type: TYPES.FETCH_MORE_DETAILS_DONE,
            payload: responseJson,
          });
        });
      } else {
        dispatch({
          type: TYPES.CLOSE_FETCH_MORE_DETAILS_LOADING,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: TYPES.CLOSE_FETCH_MORE_DETAILS_LOADING,
      });
    });
};

export const onSaveItemsResponseDone = (payload) => (dispatch) => {
  dispatch({
    type: TYPES.SAVE_ITEMS_RESPONSE_DONE,
    payload: payload,
  });
};

export const onClearResponseDone = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_RESPONSE_DONE,
  });
};

export const onFetchSuiteFaqs = (suiteId) => (dispatch) => {
  dispatch(startPRLoading());
  return client
    .fetchSuiteFaqs(suiteId)
    .then((response) => {
      dispatch(stopPRLoading());
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch(fetchFaqsNotesDocumentsDone(responseJson));
        });
      } else {
        ToastFail(ErrorMessages.error);
        dispatch(stopPRLoading());
      }
    })
    .catch(() => {
      ToastFail(ErrorMessages.error);
      dispatch(stopPRLoading());
    });
};

export const onFetchSuiteTopFaqs = (suiteId) => (dispatch) => {
  dispatch(startPRLoading());
  return client
    .fetchSuiteTopFaqs(suiteId)
    .then((response) => {
      dispatch(stopPRLoading());
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch(fetchSuiteFaqsDone(responseJson));
        });
      } else {
        ToastFail(ErrorMessages.error);
        dispatch(stopPRLoading());
      }
    })
    .catch(() => {
      ToastFail(ErrorMessages.error);
      dispatch(stopPRLoading());
    });
};

export const fetchSuiteFaqsDone = (data) => (dispatch) => {
  dispatch({
    type: TYPES.FETCH_SUITE_FAQS_DONE,
    payload: data,
  });
};
